import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo, useState } from "react";
import PropTypes from "prop-types";
import { equals, pick, sortWith, descend, ascend } from "ramda";
import { useQuery } from "react-query";
import { MultiSelect } from "@interdependence-ui";
import { extendedSystemStylesProps } from "@mixins";
import { useUnitListsContext } from "@unitLists";
import { searchOrganizations } from "@webapi/api";
import { allOrganizationTypes } from "utils/organizations";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
var SelectOrganizations = function SelectOrganizations(props) {
  var id = props.id,
    onChange = props.onChange,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? [] : _props$selected,
    _props$disabledOption = props.disabledOption,
    disabledOption = _props$disabledOption === void 0 ? function () {
      return false;
    } : _props$disabledOption,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled;
  var _useState = useState({
      q: ""
    }),
    _useState2 = _slicedToArray(_useState, 2),
    searchQuery = _useState2[0],
    setSearchQuery = _useState2[1];
  var _useUnitListsContext = useUnitListsContext(),
    unitLists = _useUnitListsContext.unitLists;
  var _useQuery = useQuery(["organizationsSearch", searchQuery], function () {
      return searchOrganizations(searchQuery);
    }, {
      enabled: searchQuery.q.length >= 3,
      initialData: []
    }),
    organizations = _useQuery.data;
  var hasNoUnitLists = unitLists.length === 0;
  var organizationTypeKeys = Object.keys(allOrganizationTypes);
  var organizationsOptions = organizations.map(function (organization) {
    return _objectSpread(_objectSpread({}, organization), {}, {
      label: organization.name,
      checked: selected.includes(organization.id),
      disabled: disabledOption(organization.id)
    });
  });
  var byType = function byType(option) {
    return organizationTypeKeys.indexOf(option.type);
  };
  var byName = function byName(option) {
    return option.label.toLowerCase();
  };
  var byHasData = function byHasData(option) {
    return !option.disabled;
  };
  var sortedOptions = sortWith([descend(byHasData), ascend(byType), ascend(byName)], organizationsOptions).slice(0, 20);
  return /*#__PURE__*/_jsx(MultiSelect, _objectSpread(_objectSpread({
    id: "select-organizations-".concat(id),
    label: "S\xF6k efter enheter",
    options: sortedOptions,
    hideLabel: true,
    disabled: disabled || hasNoUnitLists,
    disabledLabel: hasNoUnitLists ? "Skapa en ny enhetslista först" : "Inaktiv. Din lista innehåller max antal enheter.",
    searchString: (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.q) || "",
    search: function search(q) {
      return setSearchQuery({
        q: q
      });
    },
    onChange: onChange
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    placeholder: hasNoUnitLists ? "Skapa en ny enhetslista först" : !disabled ? "Sök efter enheter" : "Inaktiv. Din lista innehåller max antal enheter."
  }));
};
SelectOrganizations.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.array,
  disabledOption: PropTypes.func,
  disabled: PropTypes.bool
};
SelectOrganizations.defaultProps = {
  disabledOption: function disabledOption() {
    return false;
  }
};
export default /*#__PURE__*/memo(SelectOrganizations, function (prev, curr) {
  return equals(pick(["selected", "disabled", "disabledOptions"], prev), pick(["selected", "disabled", "disabledOptions"], curr));
});